
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cIvnv", function(module, exports) {

$parcel$export(module.exports, "SegmentHighlight", () => $f7f62572739c95e2$export$cad6e16324bd3dcc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $f7f62572739c95e2$export$cad6e16324bd3dcc({ segmentName: segmentName }) {
    const [segmentHighlight, setSegmentHighlight] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        try {
            const shouldHighlightSegments = sessionStorage.getItem('segmentsHighlight') === 'true';
            setSegmentHighlight(shouldHighlightSegments);
        } catch (err) {
        /* do nothing */ }
    }, []);
    if (segmentHighlight) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-segment-name": segmentName,
        style: {
            display: 'none'
        }
    }));
    return null;
}

});


//# sourceMappingURL=@atlaskit-internal_ufo-segment-highlight.82da2cc0.js.map
